
import { throwApiError } from '../components/lms-shared/store/error-handling-actions';
import { ObjectTypeEnumText } from '../models/ObjectTypeEnum';
import { messagesApi } from '../utils';
import { messagesActions } from './messages-slice';


export const initMessages = (courseId, uiData) => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const data = {
                refObjectId: state.application.applicationId,
                refObjectType: ObjectTypeEnumText.Application,
                targetObjects: [
                    { type: ObjectTypeEnumText.User },
                    { type: ObjectTypeEnumText.ConstUserGroup },
                    { type: ObjectTypeEnumText.Course, id: courseId },
                ],
                lang: state.translate.lang,
                ignoreMessageTypesIds: [uiData.bannerMessageTypeId]
            }
            messagesApi.messagesFilterRangePost({ messagesRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: state.translate.texts.MessageContentMessagesFilterRange, error: error, statusCode: response?.statusCode, message: "messagesFilterRangePost " + error.message, level: 1, component: "messages-actions", line: 23 }))
                } else {
                    // sort by date
                    const messages = resdata.sort((a, b) => new Date(b.sentDate) - new Date(a.sentDate)).map(m => {
                        // parse contents message to dict with lang keys
                        const parsecontents = m.contents?.reduce((obj, c) => { obj[c.lang] = c.content && JSON.parse(c.content); return obj }, {});
                        m.contents = parsecontents;
                        return m;
                    })
                    dispatch(messagesActions.initMessages({ messages: messages, unReadMessages: messages.filter(m => m.isRead === false).length }))

                }
            })
        }
        catch {

        }
    }
}
